/**
 * Official BizOne POS + Inventory brand mark.
 *
 * Usage:
 *   <Logo />               → 32px icon + "BizOne POS + Inventory" text
 *   <Logo size={40} />     → 40px icon + text
 *   <Logo iconOnly />      → just the mark, no text (for tight nav bars)
 *   <Logo variant="stack"/>→ centered stack, larger — for login/signup hero
 */
export default function Logo({ size = 28, iconOnly = false, variant = "row", className = "" }) {
  const src = "/brand/bizone-logo.png";
  if (variant === "stack") {
    return (
      <div className={`flex flex-col items-center ${className}`}>
        <img src={src} alt="BizOne POS + Inventory" width={size * 3} height={size * 3} className="object-contain drop-shadow-xl" />
      </div>
    );
  }
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <img
        src={src}
        alt="BizOne POS + Inventory"
        width={size}
        height={size}
        className="object-contain shrink-0"
        style={{ height: size, width: size }}
      />
      {!iconOnly && (
        <span className="font-display font-semibold tracking-tight">BizOne POS + Inventory</span>
      )}
    </div>
  );
}
